import React from "react";
import "react-tabs/style/react-tabs.css";
import { Badge, Button, Card } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import { Breadcrumb } from "react-bootstrap";

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY

class PartnerSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: [""],
      adminPass: ""
    };

  }

  // submitHandler = () => {
  //   this.props.history.path("/user/user-create")
  // }


  nextPath(path) {
    this.props.history.push({ pathname: path });
  }

  componentDidMount() {
    const url = process.env.REACT_APP_NODE_ENV + "/api/partners/fetchPartnerUser";
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        return response.json();
      }
    ).then(data => {
      data = CryptoJS.AES.decrypt(data.data, key)
      data = JSON.parse(data.toString(CryptoJS.enc.Utf8))
      this.setState({ userData: data })
    })
  }


  handleUserFormFields = event => {
    this.userValidator.showMessageFor(event.target.name)
    switch (event.target.id) {
      case "ufirstname":
        this.setState({ userFirstname: event.target.value });
        break;
      default:
        break;
    }
  };

  render() {
    // let userdatas = this.state.userData.map((data, index) => {
    //   let variant = "";
    //   if (data.userType === "Customer") { variant = "success" }
    //   else if (data.userType === "Partner") { variant = "primary" }
    //   else { variant = "" }
    //   return (
    //     <tr key={index}><td>{index + 1}</td><td>{data.id}</td><td>{data.userFirstName + " " + data.userLastName}</td><td> {data.userPhoneNumber}</td><td><Badge pill variant={variant}>{data.userType}</Badge></td>
    //     </tr>
    //     // <td><Button
    //     //   variant="outline-primary"
    //     //   className="btn-sm btn-bold"
    //     //   style={{ marginLeft: "5px" }}
    //     //   onClick={() =>this.nextPath("/user/user-create")
    //     //           } >
    //     //   Edit Details</Button></td>
    //   )
    // });

    let dataArr = [];
    this.state.userData.map((data) => {
      let variant = "";
      if (data.partnerType === "Fleet Operator") { variant = "success" }
      else if (data.partnerType === "Borewell Operator") { variant = "primary" }
      else if (data.partnerType === "Independent Tanker") { variant = "info" }
      else { variant = "warning" }
      if (data.user != undefined) {
        let mdData = {
          key: data.id,
          Name: data.user.userFirstName + ' ' + data.user.userLastName, MobileNumber: data.user.userPhoneNumber, PartnerId: data.partnerId,
          CompanyName: data.partnerFirmName, PartnerType: data.partnerType
        };
        dataArr.push(mdData)
      }
      return null
    });


    const columns = [
      {
        name: "Name",
        label: "User Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "MobileNumber",
        label: "Mobile Number/Login Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "CompanyName",
        label: "Partner Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "PartnerType",
        label: "Partner Type",
        options: {
          filter: false,
          sort: false,
        }
      },
      {
        name: "PartnerId",
        label: "Partner Id",
        options: {
          filter: true,
          sort: true,
        }
      },

      // {
      //   name: "apartmentId",
      //   label: "Apartment Id",
      //   options: {
      //     filter: true,
      //     sort: true,
      //   }
      // },
      // {
      //   name: "actions",
      //   label: "Actions",
      //   options: {
      //     filter: false,
      //     sort: false,
      //     customBodyRender: (value, tableMeta, updateValue) => {
      //       return (
      //         <><Button variant="outline-success" onClick={() => this.nextPath("/partner/driver/driver-details", value)} >
      //           Details </Button>
      //           {/* &nbsp;&nbsp;&nbsp;<Button variant="outline-danger" onClick={() => this.delete(value)} >
      //             Delete </Button> */}
      //         </>
      //       );
      //     }
      //   }
      // }
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false,
      downloadOptions: {
        filename: 'Partner User List.csv',
      },
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };
    let userListTable = (<Card>
      {/* <Card.Header>
        <Form>
          <Form.Row> */}
      {/* <Form.Group as={Col}>
              <Form.Label> Search </Form.Label>
              <Card>
                <SearchDefault /> </Card>
            </Form.Group> */}

      {/* <Form.Group as={Col}>
              <Form.Label>User Type</Form.Label>
              <Form.Control as="select">
                <option>Choose...</option>
                <option>Customer</option>
                <option>Partner</option>
              </Form.Control>
            </Form.Group> */}


      {/* <Form.Group as={Col}>
              <Form.Label>&nbsp;</Form.Label>
              <Button className="float-right"
                variant="outline-success"
                style={{ marginTop: "25px", width: "200px" }}
                onClick={() => this.nextPath("/user/user-create")
                }
              >
                Add User
                </Button>
            </Form.Group>
          </Form.Row>
        </Form>
      </Card.Header> */}

      <Card.Body>
        <div style={{ marginTop: "10px" }}>
          {/* <Button className="float-right"
                variant="outline-success"
                style={{ marginTop: "25px", width: "200px" }}
                onClick={() => this.nextPath("/user/user-create")
                }
              >
                Add User
                </Button> */}
          {/* <Table striped bordered hover>
    <thead>
                <tr>
                  <th>#</th>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
      <tbody>
        {userdatas} 
      </tbody>
    </Table> */}
          <MUIDataTable
            title={"Partner User List"}
            data={dataArr}
            columns={columns}
            options={options} />
        </div>
      </Card.Body>
    </Card>);

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item active>Partner User</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          {/* <Modal isOpen={this.state.modal} fade={false}
            toggle={this.userToggle} style={{ width: "1000px", display: "block" }}>
            <Card style={{ width: '50rem' }}>
              <Card.Body>
                <ModalHeader toggle={this.userToggle}>
                  Add customer
                </ModalHeader>
                <ModalBody>

                  <div className="form-group row">

                    <div className="col-lg-4">
                      <label>Password :</label>
                      <input type="text" className="form-control" name="adminPass" id="uAdminPass" required placeholder="Enter the password" value={this.state.adminPass} onChange={this.handleFormFields} />
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter><div className="col-8 float-center">
                  <Button variant="outline-primary" onClick={this.userSubmit}> Save </Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={this.userToggle}> Cancel </Button>
                </div>
                </ModalFooter>
              </Card.Body>
            </Card>
          </Modal> */}
        </div>
        {userListTable}
      </>
    );
  }
}

export default withRouter(PartnerSummary);
